var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Wizard',{attrs:{"steps":_vm.stepValues,"currentStep":_vm.currentStep}}),_c('TabbedPortletContainer',[_c('router-view',{attrs:{"name":"content"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }